import { InMemoryCache } from '@apollo/client';
const graphQLCache = new InMemoryCache({
    // Fragments on RP_ReviewEntityData are skipped unless Apollo knows the members.
    possibleTypes: {
        RP_ReviewEntityData: [
            'RP_EPAnswerData',
            'RP_EPQPData',
            'RP_EPEFData',
            'RP_EPEFImagesData',
            'RP_EPNoteReviewData',
        ],
    },
    typePolicies: {
        EPQuestion: {
            merge: true,
            fields: {
                data: {
                    merge: true,
                },
                config: {
                    merge: true,
                },
                ancestorsDetails: {
                    merge: true,
                },
                questionPaper: {
                    merge: true,
                },
                duplicates: {
                    merge: false,
                },
            },
        },
        EPAnswer: {
            merge: true,
            fields: {
                data: {
                    merge: true,
                },
                config: {
                    merge: true,
                },
            },
        },
        EPAnswerData: {
            merge: true,
            fields: {
                latestAnswer: {
                    merge: true,
                },
            },
        },
        EPSubject: {
            merge: true,
            fields: {
                data: {
                    merge: true,
                },
            },
        },
        CommunityQuestion: {
            fields: {
                data: {
                    merge: true,
                },
            },
        },
        CommunityAnswer: {
            fields: {
                data: {
                    merge: true,
                },
            },
        },
        CommunityReply: {
            fields: {
                data: {
                    merge: true,
                },
            },
        },
        Author: {
            fields: {
                details: {
                    merge: true,
                },
                reputation: {
                    merge: true,
                },
            },
        },
    },
});
export function addTypePolicies(typePolicies) {
    graphQLCache.policies.addTypePolicies(typePolicies);
}
export default graphQLCache;
